import { Types, Actions } from './actions';
import authApi from '~/api';
import { LOGOUT_URL } from '~/api/constants';
import { LOGOUT } from '~/components/analytics/constants';
import track from '~/components/analytics/track';
import { Actions as AuthActions } from '~/store/auth/actions';
import { Actions as LoginActions } from '~/store/login/actions';

type LogoutResponse =
  | {
      redirectTo: string;
    }
  | { success: 'logged out' };

const middleware = (store: any) => (next: any) => (action: any) => {
  const { dispatch } = store;
  if (action.type === Types.LOGOUT_REQUEST) {
    authApi
      .get(LOGOUT_URL)
      .then(res => {
        const { ok, problem, status } = res;
        const data = res.data as LogoutResponse;
        if (ok) {
          if ('redirectTo' in data && data.redirectTo) {
            // the user is being redirected to another page
            // expected when user management is using a 3rd party IdP
            // we use replace instead of push to avoid the user going back to the logout redirect
            window.location.replace(data.redirectTo);
            return;
          }
          dispatch(Actions.LOGOUT_SUCCESS());
          dispatch(LoginActions.CLEAR_LOGIN());
        } else if (status === 401) {
          // this means the user isn't logged in
          // not a problem
          dispatch(Actions.LOGOUT_SUCCESS());
          dispatch(LoginActions.CLEAR_LOGIN());
        } else {
          dispatch(Actions.LOGOUT_FAILURE(problem));
        }
      })
      .catch(err => {
        dispatch(Actions.LOGOUT_ERROR(err));
      });
  }
  if (action.type === Types.LOGOUT_SUCCESS) {
    dispatch(AuthActions.LOGOUT_AUTH());
    track(LOGOUT);
  }
  next(action);
};

export default middleware;
